<script setup>
import {inject} from "vue";

const list = inject('needs');
</script>

<template>
    <div v-if="list !== null">
        <template v-if="!list.length">
            <ul class="needs-steps">
                <li class="needs-steps__search"><p>Enter your business challenges</p></li>
                <li class="needs-steps__ai"><p>We'll use AI to match you with startup solutions tailored to your need</p></li>
                <li class="needs-steps__ecosystem"><p>Partnered Ecosystems will suggest proprietary startups on their roster</p></li>
            </ul>

            <h3 class="heading3 text-center">Add your needs and we’ll do the rest!</h3>
        </template>

        <template v-else>
            <div v-for="need in list" :key="need.id" class="card card--need">
                <h5 class="heading5"><a :href="`/needs/${need.id}`" target="_blank">{{ need.name }}</a></h5>

                <div class="card--need__content">
                    <div class="card--need__text">
                        <p>{{ need.description }}</p>
                    </div>

                    <a href="#" class="link-arrow">View New Matches</a>
                </div>

                <ul class="list-info">
                    <li class="list-info__startup">9 Solutions</li>
                    <li class="list-info__score">Fit Score: 7%</li>
                </ul>

                <div class="needs-stats">
                    <div class="needs-stats__progress" style="width: 700px;"></div>
                    <ul class="needs-stats__steps">
                        <li class="needs-stats__steps__created needs-stats__steps__active">Need Created</li>
                        <li class="needs-stats__steps__matched needs-stats__steps__active">Solutions Matched</li>
                        <li class="needs-stats__steps__reviewed">Solutions Reviewed</li>
                        <li class="needs-stats__steps__escalated">Need Escalated</li>
                    </ul>
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped>

</style>
